import styled, { css } from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 15;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.98);
`;

const StyledHeadContainer = styled.div`
	display: grid;
	grid-template-columns: 20% 60% 20%;
	padding: 20px;
	align-items: center;
`;

const StyledBackButton = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	justify-self: start;
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 6px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${TextLabel} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}

		${TextLabel} {
			color: #000000;
		}
	}
`;

const StyledCrossButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	justify-self: end;
	width: 40px;
	height: 40px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledMainContainer = styled.div`
	position: relative;
	width: 430px;
	height: 590px;
	margin: 0 auto;
	padding: 10px 0 20px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledPhotoContainer = styled.div`
	position: relative;
	width: 430px;
	height: 156px;
	padding-top: 12px;

	img {
		width: 100%;
		user-select: none;
		pointer-events: none;
		border-radius: 10px;
	}
`;

const StyledInfoHintContainer = styled.div<{ $position: 'left' | 'right' }>`
	position: absolute;
	top: 0;
	${(props) =>
		props.$position === 'left' &&
		css`
			left: 0;
		`}
	${(props) =>
		props.$position === 'right' &&
		css`
			right: 0;
		`}
`;

const StyledInfoHint = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	gap: 4px;
	height: 20px;
	padding: 0 5px;
	background-color: #ffffff;
	border-radius: 6px;
	transition: background-color 0.3s ease;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${TextLabel} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
		transition: color 0.3s ease;
	}
`;

const StyledTable = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	justify-content: space-between;
	row-gap: 14px;
	margin-top: 17px;
	padding: 20px 17px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	${TextLabel} {
		color: #ffffff;

		&:nth-child(2n + 1) {
			font-weight: 400;
			font-size: 14px;
			opacity: 0.5;
		}

		&:nth-child(2n) {
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
			text-align: right;

			span {
				font-weight: 400;
				font-size: 14px;
				opacity: 0.5;
			}
		}
	}
`;

const StyledStateContainer = styled.div`
	width: 430px;
	margin-top: 17px;
`;

const StyledTuningContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
	width: 430px;
	margin-top: 17px;

	& > ${TextLabel} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
		text-align: center;
	}
`;

const StyledTuningGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 20px;
`;

const StyledTuningItem = styled.div<{ $active?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 19px;
	width: auto;
	height: 100px;
	padding-top: 20px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	border: 1px solid
		${(props) => (props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.1)')};
	border-radius: 10px;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
	}

	${TextLabel} {
		font-size: 12px;
		color: #ffffff;
	}
`;

export {
	StyledContainer,
	StyledHeadContainer,
	StyledBackButton,
	StyledCrossButton,
	StyledMainContainer,
	StyledPhotoContainer,
	StyledTable,
	StyledStateContainer,
	StyledInfoHintContainer,
	StyledInfoHint,
	StyledTuningContainer,
	StyledTuningGrid,
	StyledTuningItem,
};
